// extracted by mini-css-extract-plugin
export default {"root":"IconFilter_root__d5LOm"};